// import 'bootstrap/js/dist/util.js';
import 'bootstrap/js/dist/collapse.js';

import './modules/menu-collapsible.js';
import './modules/menu-multilevel.js';

const checkMonthSelect = () => {
  if (!$("#filterYear").val()) {
    $("#filterMonth").prop('disabled', 'disabled');
  } else {
    $("#filterMonth").prop('disabled', false);
  }
}

(function($){

  $('nav.menu-collapsible').menuCollapsible({});
  $('nav.menu-multilevel').menuMultiLevel({});

  if($('.account-orders, .supervisor-view').length > 0) {
    checkMonthSelect();

    $("#filterYear").change(function() {
      checkMonthSelect();
    });
  }

})(jQuery);



// WEBPACK FOOTER //
// ./grails-app/assetsSrc/scripts/account.js